import { initWidget, secureLocalStorage } from './widget';
import endpoints from './widget/define/endpoints';

import AddToWishList from './widget/component/AddToWishList';
import CircleCard from './widget/component/CircleCard/CircleCard';
import { FilterResultsBeta } from './widget/component/FilterResults';
import Reviews from './widget/component/Reviews';

const initSpecificPageWidgets = () => {
  const props = {
    endpoints,
  };

  initWidget('add-to-wish-list', AddToWishList, props);
  initWidget('circle-card', CircleCard, props);

  secureLocalStorage.getItem('SSR_FirstLoad') && SSRinit();
};

const SSRinit = function () {
  initWidget('filter-results-beta', FilterResultsBeta, { endpoints });
  initWidget('add-to-wish-list', AddToWishList, { endpoints });
  initWidget('reviews', Reviews, { endpoints });
  secureLocalStorage.setItem('SSR_FirstLoad', true);
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initSpecificPageWidgets.bind(this)
  );
} else {
  initSpecificPageWidgets();
}

if (!secureLocalStorage.getItem('SSR_FirstLoad')) {
  document.addEventListener('click', fakeSsrInit);
  document.addEventListener('scroll', fakeSsrInit);
}

function fakeSsrInit(event) {
  document.removeEventListener('click', fakeSsrInit);
  document.removeEventListener('scroll', fakeSsrInit);

  SSRinit();

  if (event.type === 'click' && !event.target.className.includes('iubenda')) {
    setTimeout(() => {
      document.elementFromPoint(event.clientX, event.clientY).click();
    }, 50);
  }
}
